import { useEffect } from 'react';
import { useUIStore } from '@/store/uiStore';

function syncThemeColorMeta(resolved: 'light' | 'dark') {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', resolved === 'dark' ? '#0c0d12' : '#ffffff');
}

function apply(theme: 'light' | 'dark') {
  const root = window.document.documentElement;
  root.classList.remove('light', 'dark');
  root.classList.add(theme);
  syncThemeColorMeta(theme);
}

export function useTheme() {
  const { theme, setTheme } = useUIStore();

  useEffect(() => {
    if (theme !== 'system') {
      apply(theme);
      return;
    }

    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    apply(mql.matches ? 'dark' : 'light');

    const onChange = (e: MediaQueryListEvent) => apply(e.matches ? 'dark' : 'light');
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [theme]);

  return { theme, setTheme };
}
